/* Go Living — Theme JS */

document.addEventListener('DOMContentLoaded', function () {

  /* ---- Mobile menu ---- */
  const toggle = document.getElementById('menuToggle');
  const mobileNav = document.getElementById('mobileNav');
  const mobileClose = document.getElementById('mobileNavClose');

  if (toggle && mobileNav) {
    toggle.addEventListener('click', () => mobileNav.classList.add('open'));
    mobileClose && mobileClose.addEventListener('click', () => mobileNav.classList.remove('open'));
  }

  /* ---- PDP: thumbnail switcher ---- */
  const thumbs = document.querySelectorAll('.thumb[data-src]');
  const mainImg = document.querySelector('.gallery .main-img img');

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', function () {
      thumbs.forEach(t => t.classList.remove('active'));
      this.classList.add('active');
      if (mainImg) mainImg.src = this.dataset.src;
    });
  });

  /* ---- PDP: quantity controls ---- */
  const qtyInputs = document.querySelectorAll('.qty input');
  qtyInputs.forEach(input => {
    const minus = input.previousElementSibling;
    const plus = input.nextElementSibling;
    minus && minus.addEventListener('click', () => {
      const val = parseInt(input.value) || 1;
      if (val > 1) input.value = val - 1;
    });
    plus && plus.addEventListener('click', () => {
      input.value = (parseInt(input.value) || 1) + 1;
    });
  });

  /* ---- Cart count update after add-to-cart ---- */
  document.querySelectorAll('[data-add-to-cart]').forEach(form => {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const btn = this.querySelector('[type=submit]');
      if (btn) { btn.disabled = true; btn.textContent = 'Agregando…'; }
      const data = new FormData(this);
      fetch('/cart/add.js', { method: 'POST', body: data })
        .then(r => r.json())
        .then(() => refreshCartCount())
        .then(() => {
          if (btn) { btn.disabled = false; btn.textContent = 'Agregar al carrito'; }
        })
        .catch(err => {
          console.error(err);
          if (btn) { btn.disabled = false; btn.textContent = 'Agregar al carrito'; }
        });
    });
  });

  /* ---- Cart page: quantity controls & remove ---- */
  function refreshCartCount() {
    return fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        document.querySelectorAll('.cart-count').forEach(el => {
          el.textContent = cart.item_count;
        });
        return cart;
      });
  }

  function updateCartItem(key, quantity) {
    const row = document.querySelector(`.cart-item[data-key="${key}"]`);
    if (row) row.classList.add('updating');

    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(r => r.json())
      .then(cart => {
        refreshCartCount();

        const subtotalEl = document.querySelector('.cart-subtotal');
        if (subtotalEl) {
          subtotalEl.textContent = formatMoney(cart.total_price);
        }

        if (quantity === 0) {
          if (row) row.remove();
          if (cart.item_count === 0) location.reload();
          return;
        }

        if (row) {
          const totalEl = row.querySelector('.cart-item-total');
          if (totalEl) {
            const item = cart.items.find(i => i.key === key);
            if (item) totalEl.textContent = formatMoney(item.line_price);
          }
          row.classList.remove('updating');
        }
      })
      .catch(err => {
        console.error(err);
        if (row) row.classList.remove('updating');
      });
  }

  function formatMoney(cents) {
    const amount = cents / 100;
    return '$' + amount.toLocaleString('es-CL', { minimumFractionDigits: 0 });
  }

  /* Remove buttons */
  document.querySelectorAll('.cart-item-remove').forEach(btn => {
    btn.addEventListener('click', function () {
      updateCartItem(this.dataset.key, 0);
    });
  });

  /* Quantity +/- on cart page */
  document.querySelectorAll('.cart-item .qty-btn').forEach(btn => {
    btn.addEventListener('click', function () {
      const key = this.dataset.key;
      const input = document.querySelector(`.qty-input[data-key="${key}"]`);
      if (!input) return;
      let val = parseInt(input.value) || 1;
      if (this.dataset.action === 'minus') val = Math.max(1, val - 1);
      if (this.dataset.action === 'plus') val = val + 1;
      input.value = val;
      updateCartItem(key, val);
    });
  });

  /* Quantity input change (direct edit) */
  document.querySelectorAll('.cart-item .qty-input').forEach(input => {
    let timer;
    input.addEventListener('change', function () {
      clearTimeout(timer);
      const val = Math.max(1, parseInt(this.value) || 1);
      this.value = val;
      timer = setTimeout(() => updateCartItem(this.dataset.key, val), 400);
    });
  });

});
